document.addEventListener('DOMContentLoaded', function() {
  function resizeIframe(height) {
    const iframe = document.getElementById('externalIframe');
    if (iframe) {
      iframe.style.height = height + 'px';
    }
  }

  window.addEventListener('message', function(event) {
    if (event.data && event.data.type === 'resize-iframe') {
      const newHeight = event.data.height;
      resizeIframe(newHeight);
    }
  });
});
